import { render, staticRenderFns } from "./CellRendererCompany.vue?vue&type=template&id=92a330b2&scoped=true&"
import script from "./CellRendererCompany.vue?vue&type=script&lang=js&"
export * from "./CellRendererCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92a330b2",
  null
  
)

export default component.exports